<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__8_relationships')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__8_relationships_is_iucn')}}</strong></label>
        <div class="mt-3"></div>
        <radio name="diligence.isOrgIucnMember" value="true" v-model="GrantForm.revisionModel.diligence.isOrgIucnMember">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.isOrgIucnMember" value="false" v-model="GrantForm.revisionModel.diligence.isOrgIucnMember">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
      <div class="col-lg-12">
        <div class="mt-3"></div>
        <label><strong>{{$t('medium_grant.diligence__8_relationships_has_worked_iucn')}}</strong></label>
        <div class="mt-3"></div>
        <radio name="diligence.hasOrgWorkedIucn" value="true" v-model="GrantForm.revisionModel.diligence.hasOrgWorkedIucn">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.hasOrgWorkedIucn" value="false" v-model="GrantForm.revisionModel.diligence.hasOrgWorkedIucn">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="mt-3">
          <label>{{$t('medium_grant.diligence__8_relationships_iucn_text')}}</label>
          <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.diligence.iucnText"
            >
            </textarea>
          </base-input>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>